import i18n from '../../../i18n';

const productName = 'Chime';
const installationInstructions = {
  intro: {
    currentStep: 'intro',
    currentStepName: 'installationIntro',
    includeInstallationSteps: false,
    includePairingProcess: false,
    isLastPage: false,
    nextStep: 'letsGetStarted',
    nextStepName: 'instructions',
    prevStepName: 'https://return-to-app',
    primaryText: i18n.t('instructions.A685.intro.title', {productName}),
    haloDeviceResource: require('@/assets/device-models/A685/a685_halo.png'),
    resourceType: 'image',
    secondaryText: i18n.t('instructions.A685.intro.description', {productName}),
    continueButtonTx: 'common.startPairing',
  },
  letsGetStarted: {
    continueButtonTx: 'common.ready',
    currentStep: 'letsGetStarted',
    isLastPage: true,
    lastPageExitUrl: 'https://www.exit-installation-instructions-flow',
    prevStep: 'intro',
    prevStepName: 'installationIntro',
    headerOverridingClass: 'background-gray',
    primaryText: i18n.t('instructions.A685.letsgetstarted.title', {productName}),
    resource: require('@/assets/device-models/A685/a685.png'),
    resourceType: 'image',
    secondaryText: i18n.t('instructions.A685.letsgetstarted.description', {productName}),
    steps: [
      {
        titleTx: 'instructions.A685.letsgetstarted.one.title',
        description: i18n.t('instructions.A685.letsgetstarted.one.description', {productName}),
        stepNumber: 1
      },
      {
        titleTx: 'instructions.A685.letsgetstarted.two.title',
        descriptionTx:  'instructions.A685.letsgetstarted.two.description',
        stepNumber: 2
      },
    ],
    alternateNextStep: {
      nextStep: 'pairingModeReset',
      nextStepName: 'instructions',
      title: 'Read instructions',
    }
  },
  pairingModeReset: {
    prevStep: 'letsGetStarted',
    headerIcon: 'arrowGrey',
    prevStepName: 'instructions',
    currentStep: 'pairingModeReset',
    resourceType: 'image',
    resource: require('@/assets/device-models/A685/a685_reset.png'),
    resourceOverridingClass: 'background-none',
    primaryText: i18n.t('instructions.A685.pairingmodereset.title', {productName}),
    secondaryText: i18n.t('instructions.A685.pairingmodereset.description', {productName}),
    steps: [
      {
        titleTx: 'instructions.A685.pairingmodereset.one.title',
        descriptionTx:'instructions.A685.pairingmodereset.one.description',
        stepNumber: 1
      },
      {
        titleTx: 'instructions.A685.pairingmodereset.two.title',
        descriptionTx: 'instructions.A685.pairingmodereset.two.description',
        stepNumber: 2
      },
    ],
    isLastPage: true,
    lastPageExitUrl: 'https://www.exit-installation-instructions-flow',
  }
};

export default installationInstructions;
